module.exports = __webpack_public_path__ + "static/media/im.8c10222d.svg";